export default __webpack_public_path__ + "static/media/responsabilidade_civil_profissional.765ffd43.png";